import { PlaybackProvider } from '@app/core/playback/context/PlaybackProvider';
import { isStationTranscriptionEnabled } from '@app/modules/fragments/screens/view/components/transcription/lib/is-transcription-enabled';
import { Box, Grid, Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useFragment } from '../../hooks/useFragment';
import { TranscriptionPanel } from '../transcription/panel/TranscriptionPanel';
import { FragmentDescriptionSection } from './FragmentDescriptionSection';
import { FragmentMedia } from './FragmentMedia';
import { FragmentMediaLoggerActions } from './FragmentMediaLoggerActions';
import { FragmentMetadata } from './FragmentMetadata';

/**
 * Fragment view:
 * - Metadata (date, duration, tags, creator) at the top; description at the bottom.
 * - Logger open-in-stream actions sit under the media player as one group.
 * - md and below: metadata, media, transcription, description (stacked full width).
 * - lg and above: metadata/media/description in the left column and transcription in the right.
 */
export function FragmentMediaDetail() {
  const { station } = useFragment();
  const theme = useTheme();
  const isMdOrLower = useMediaQuery(theme.breakpoints.down('lg'));
  const hasTranscription = isStationTranscriptionEnabled(station);

  const mediaBlock = (
    <Box sx={{ width: '100%' }}>
      <FragmentMedia />
      <FragmentMediaLoggerActions />
    </Box>
  );

  return (
    <PlaybackProvider>
      {isMdOrLower ? (
        <Stack spacing={2}>
          <FragmentMetadata />
          {mediaBlock}
          {hasTranscription && <TranscriptionPanel />}
          <FragmentDescriptionSection />
        </Stack>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12} lg={hasTranscription ? 8 : 12}>
            <Stack spacing={2}>
              <FragmentMetadata />
              {mediaBlock}
              <FragmentDescriptionSection />
            </Stack>
          </Grid>
          {hasTranscription && (
            <Grid item xs={12} lg={4}>
              <TranscriptionPanel />
            </Grid>
          )}
        </Grid>
      )}
    </PlaybackProvider>
  );
}
